<template>
  <v-layout>
    <template v-for="(item, i) in timeConfig">
      <v-tooltip
        :key="`${i}-time-item`"
        top
      >
        <template #activator="{ on }">
          <strong
            :class="item.color"
            v-on="on"
          >
            {{ item.name }}:
            {{ item.time }}
            /
            {{ jobs[item.type] }}
            {{ jobs[item.type] === 1 ? 'job' : 'jobs' }}
          </strong>
        </template>

        Total time and jobs for
      </v-tooltip>

      <strong
        v-if="i < 2"
        :key="`${i}-time-separator`"
        class="mx-2"
      >
        |
      </strong>
    </template>
  </v-layout>
</template>

<script>
import {
  generateTimeStrFromHoursMinutesObj,
  calculateTimeByOverMinutesFromHoursMinutesObj,
} from '../_helpers/time';

export default {
  name: 'PbDashboardTotalTimeAndJobs',

  props: {
    time: {
      type: Object,
      required: true,
    },

    jobs: {
      type: Object,
      required: true,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    totalTime() {
      return Object.values(this.time).reduce((acc, { hours, minutes }) => {
        acc.hours += hours;
        acc.minutes += minutes;

        return calculateTimeByOverMinutesFromHoursMinutesObj(acc);
      }, { hours: 0, minutes: 0 });
    },

    timeConfig() {
      return [
        {
          type: 'groups',
          name: 'Dashboard',
          color: 'success--text',
          time: generateTimeStrFromHoursMinutesObj(this.time.groups),
        },
        {
          type: 'queue',
          name: 'Printing',
          color: 'warning--text',
          time: generateTimeStrFromHoursMinutesObj(this.time.queue),
        },
        {
          type: 'total',
          name: 'Total',
          color: 'info--text',
          time: generateTimeStrFromHoursMinutesObj(this.totalTime),
        },
      ];
    },
  },
};
</script>
